/* Category photographs enhance real section content; the six-card fallback is rendered by Liquid. */
(() => {
  const selector='.aarons-category-editorial[data-category-editorial]';
  if(window.AaronsCategoryEditorial){window.AaronsCategoryEditorial.init(document);return;}
  const instances=new Map();

  function selectProducts(root){
    const grid=root.querySelector('.program-products');
    if(!grid)return;
    const items=[...grid.querySelectorAll('[data-b2b-product-index]')];
    if(items.length<=6){items.forEach(item=>{item.hidden=false;});return;}
    const ordered=items.slice().sort((left,right)=>Number(left.dataset.b2bProductIndex)-Number(right.dataset.b2bProductIndex));
    const pool=ordered.slice(1);
    let seed=Date.now()+Math.floor(Math.random()*100000);
    for(let index=pool.length-1;index>0;index--){
      seed=(seed*9301+49297)%233280;
      const other=Math.floor((seed/233280)*(index+1));
      [pool[index],pool[other]]=[pool[other],pool[index]];
    }
    const selected=[ordered[0],...pool.slice(0,5)],visible=new Set(selected);
    items.forEach(item=>{item.hidden=!visible.has(item);});
    selected.forEach(item=>{item.hidden=false;grid.appendChild(item);});
  }

  function mount(root){
    if(instances.has(root))return;
    selectProducts(root);
    const controller=new AbortController();
    const on=(target,type,handler,options={})=>target?.addEventListener(type,handler,{...options,signal:controller.signal});
    let stopped=false,requestId=0,scheduled=0,pendingPhoto=null;
    instances.set(root,()=>{
      stopped=true;requestId++;pendingPhoto=null;
      cancelAnimationFrame(scheduled);controller.abort();
      root.classList.remove('category-story-ready');instances.delete(root);
    });

    const configNode=root.querySelector('[data-category-config]');
    let config={};
    if(configNode){
      try{config=JSON.parse(configNode.textContent);}catch(error){
        console.warn('Category photographs remain available in static reading mode.');
      }
    }
    const labels={
      unavailable:typeof config.labels?.unavailable==='string'?config.labels.unavailable:'The photograph could not load.',
      retry:typeof config.labels?.retry==='string'?config.labels.retry:'Retry photograph'
    };

    for(const image of root.querySelectorAll('[data-natural-photo]')){
      const figure=image.closest('figure');
      const message=figure?.querySelector('[data-natural-error]');
      const retry=figure?.querySelector('[data-retry-natural]');
      const source=image.getAttribute('src')||'';
      if(!message||!retry||!source)continue;
      on(image,'error',()=>{
        image.dataset.failed='true';message.textContent=labels.unavailable;
        message.hidden=false;retry.hidden=false;retry.disabled=false;retry.textContent=labels.retry;
      });
      on(image,'load',()=>{
        image.removeAttribute('data-failed');message.hidden=true;retry.hidden=true;
        retry.disabled=false;retry.textContent=labels.retry;
      });
      on(retry,'click',()=>{
        retry.disabled=true;image.removeAttribute('data-failed');
        image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=source;
      });
      if(image.complete&&!image.naturalWidth)image.dispatchEvent(new Event('error'));
    }

    const hero=root.querySelector('[data-hero-image]');
    const heroError=root.querySelector('[data-hero-error]');
    const heroRetry=root.querySelector('[data-retry-hero]');
    if(hero&&heroError){
      const source=hero.getAttribute('src')||'';
      on(hero,'error',()=>{hero.dataset.failed='true';heroError.hidden=false;});
      on(hero,'load',()=>{hero.removeAttribute('data-failed');heroError.hidden=true;});
      if(source)on(heroRetry,'click',()=>{hero.src=source;});
      else if(heroRetry)heroRetry.hidden=true;
      if(hero.complete&&!hero.naturalWidth)hero.dispatchEvent(new Event('error'));
    }

    const story=root.querySelector('.folio-story');
    const stage=story?.querySelector('[data-photo-stage]');
    const layers=stage?[...stage.querySelectorAll('[data-photo-layer]')]:[];
    const chapters=story?[...story.querySelectorAll('[data-chapter]')]:[];
    const chapterLinks=story?[...story.querySelectorAll('[data-chapter-link]')]:[];
    const photoError=story?.querySelector('[data-photo-error]');
    const photoCaption=story?.querySelector('[data-photo-caption]');
    const retryPhoto=story?.querySelector('[data-retry-photo]');
    if(!story||layers.length!==2||chapters.length<2||chapters.length>3||!photoError||!photoCaption||!retryPhoto)return;
    const photographs={};
    for(const key of chapters.map(chapter=>chapter.dataset.chapter)){
      const photo=config.photographs?.[key];
      if(!photo||typeof photo.src!=='string'||!photo.src.trim())return;
      photographs[key]={src:photo.src,label:typeof photo.label==='string'?photo.label:key,alt:typeof photo.alt==='string'?photo.alt:''};
    }
    const desktop=matchMedia('(min-width: 901px)');
    const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
    let current='exterior',visiblePhoto='exterior',visibleLayer=0,failedPhoto=null,manualTarget=null;

    function imageReady(src){
      return new Promise((resolve,reject)=>{
        const image=new Image();image.decoding='async';
        image.onload=async()=>{
          try{if(image.decode)await image.decode();}catch(error){if(!image.naturalWidth){reject(error);return;}}
          resolve(image);
        };
        image.onerror=()=>reject(new Error('Photograph unavailable'));image.src=src;
      });
    }

    async function showPhotograph(key,{force=false}={}){
      if(stopped||!desktop.matches)return;
      if(!force&&key===pendingPhoto)return;
      if(!force&&key===visiblePhoto&&layers[visibleLayer].complete&&layers[visibleLayer].naturalWidth>0){
        requestId++;pendingPhoto=null;failedPhoto=null;
        stage.dataset.photoState='ready';photoError.textContent='';retryPhoto.hidden=true;return;
      }
      const token=++requestId;pendingPhoto=key;stage.dataset.photoState='loading';
      try{
        await imageReady(photographs[key].src);
        if(stopped||token!==requestId)return;
        const incoming=layers[1-visibleLayer],outgoing=layers[visibleLayer];
        incoming.removeAttribute('srcset');incoming.removeAttribute('sizes');
        incoming.src=photographs[key].src;incoming.alt=photographs[key].alt;incoming.removeAttribute('data-failed');
        incoming.removeAttribute('aria-hidden');incoming.classList.add('is-current');
        outgoing.classList.remove('is-current');outgoing.setAttribute('aria-hidden','true');
        visibleLayer=1-visibleLayer;visiblePhoto=key;pendingPhoto=null;failedPhoto=null;
        stage.dataset.photo=key;stage.dataset.photoState='ready';
        photoCaption.textContent=photographs[key].label;photoError.textContent='';retryPhoto.hidden=true;
      }catch(error){
        if(stopped||token!==requestId)return;
        pendingPhoto=null;failedPhoto=key;stage.dataset.photoState='error';
        if(layers[visibleLayer].complete&&!layers[visibleLayer].naturalWidth)layers[visibleLayer].dataset.failed='true';
        photoError.textContent=labels.unavailable;retryPhoto.hidden=false;retryPhoto.textContent=labels.retry;
      }
    }

    function selectChapter(key,{force=false}={}){
      if(!chapters.some(chapter=>chapter.dataset.chapter===key))return;
      current=key;story.dataset.current=key;
      chapters.forEach(chapter=>{chapter.dataset.active=String(chapter.dataset.chapter===key);});
      chapterLinks.forEach(link=>{
        if(link.dataset.chapterLink===key)link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      });
      showPhotograph(key,{force});
    }
    function syncScroll(){
      scheduled=0;if(stopped||!desktop.matches)return;
      const middle=innerHeight*.5;
      let closest=chapters[0],distance=Infinity;
      for(const chapter of chapters){
        const box=chapter.getBoundingClientRect(),next=Math.abs((box.top+box.bottom)*.5-middle);
        if(next<distance){distance=next;closest=chapter;}
      }
      const key=closest.dataset.chapter;
      if(manualTarget){if(key===manualTarget)manualTarget=null;else return;}
      if(key!==current)selectChapter(key);
    }
    function scheduleScroll(){if(!scheduled&&!stopped)scheduled=requestAnimationFrame(syncScroll);}
    function cancelManual(){manualTarget=null;}
    chapterLinks.forEach(link=>on(link,'click',event=>{
      if(event.button!==0||event.metaKey||event.ctrlKey||event.altKey||event.shiftKey)return;
      const key=link.dataset.chapterLink,target=chapters.find(chapter=>chapter.dataset.chapter===key);
      if(!target)return;
      event.preventDefault();manualTarget=key;selectChapter(key);
      history.replaceState(null,'','#'+target.id);
      target.scrollIntoView({behavior:reducedMotion.matches?'instant':'smooth',block:desktop.matches?'center':'start'});
      scheduleScroll();
    }));
    on(retryPhoto,'click',()=>{
      const key=failedPhoto||current;
      manualTarget=key;selectChapter(key,{force:true});
      chapters.find(chapter=>chapter.dataset.chapter===key).scrollIntoView({behavior:reducedMotion.matches?'instant':'smooth',block:'center'});
      scheduleScroll();
    });

    function syncLayout(){
      story.dataset.layout=desktop.matches?'sticky':'natural';
      if(desktop.matches)showPhotograph(current);
      else{requestId++;pendingPhoto=null;}
      scheduleScroll();
    }
    on(window,'scroll',scheduleScroll,{passive:true});
    on(window,'resize',syncLayout,{passive:true});
    on(window,'wheel',cancelManual,{passive:true});
    on(window,'touchstart',cancelManual,{passive:true});
    on(window,'pointerdown',cancelManual,{passive:true});
    on(window,'keydown',event=>{if(['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(event.key))cancelManual();});
    on(window,'pagehide',()=>{stopped=true;requestId++;pendingPhoto=null;cancelAnimationFrame(scheduled);scheduled=0;});
    on(window,'pageshow',event=>{if(event.persisted){stopped=false;syncLayout();}});
    root.classList.add('category-story-ready');syncLayout();
  }

  function init(scope){
    if(scope.matches?.(selector))mount(scope);
    scope.querySelectorAll(selector).forEach(mount);
  }
  window.AaronsCategoryEditorial={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    for(const [root,destroy] of instances)if(event.target===root||event.target.contains(root))destroy();
  });
})();
